<div class="dialogContent calcHeight content">
    <irb-settings-dialog-banner [showUnsavedChangesWarning]="showUnsavedChangesWarning"
                                [showExpandControls]="showExpandControls"
                                [isModified]="isModified" [validationErrorTemplates]="validationErrorTemplates" (save)="save()">Model Market Center Notes
    </irb-settings-dialog-banner>
    <div class="body">
        <div class="mmc-settings-mmc-notes-container">
            <div class="mmc-settings-mmc-notes-add-container">
                <div class="mmc-settings-mmc-notes-add-container-row">
                    <div class="mmc-settings-mmc-notes-add-container-element">
                        <div class="mmc-settings-mmc-notes-add-container-element-label">Manager</div>
                        <div class="mmc-settings-mmc-notes-add-container-element-input">
                            <irb-dropdown-filter  #irbModelProviderDropdown
                                                 (search)="searchModelProviders($event)" size="30"
                                                 (selection)="onModelProviderSelection($event)"
                                                 [(value)]="selectedModelProvider"
                                                 [placeholder]="'-Select-'">

                            </irb-dropdown-filter>
                        </div>
                    </div>
                    <div class="mmc-settings-mmc-notes-add-container-element">
                        <div class="mmc-settings-mmc-notes-add-container-element-label">Model</div>
                        <div class="mmc-settings-mmc-notes-add-container-element-input">
                            <irb-dropdown-filter  #irbModelDropdown
                                                 (search)="searchModels($event)" size="30"
                                                 [(value)]="selectedModel"
                                                  [disabled]="!selectedModelProvider"
                                                 [placeholder]="'-Select-'">

                            </irb-dropdown-filter>
                        </div>
                        <div class="mmc-settings-mmc-notes-add-container-element-button">
                            <button class="btn-medium-secondary btn-spacer" (click)="onAddMmcNote()"
                                    [disabled]="!selectedModelProvider">Create note
                            </button>
                        </div>
                    </div>

                </div>
            </div>
            <div class="mmc-counter-label"> {{getNonDeletedNotes() + ' current notes'}}</div>
            <irb-inventory-grid
                    class="mmc-settings-mmc-notes-grid-ag"
                    [style.width]="'100%'"
                    [gridHeight]="'600px'"
                    [style.minHeight]="'600px'"
                    [showSideBar]="false"
                    [gridOptions]="gridOptions"
                    [frameworkComponents]='frameworkComponents'
                    [rowData]="modelMarketNotifications"
                    (cellValueChanged)="onCellValueChanged($event)"
                    (gridReady)="onGridReady($event)"></irb-inventory-grid>
        </div>


    </div>
</div>
